<script lang="ts" setup>
import {useQuasar} from 'quasar';
import {useRouter} from 'vue-router';
import {useSessionStore} from 'src/store';
import {useI18n} from 'vue-i18n';
import {onMounted} from 'vue';
import {handleApiRequest} from 'src/api/handleApiRequest';
import {setProcedureConsent} from 'src/api/endpoints/userWeb';
import Svg from '@/components/Svg.vue';
import {shieldHeart} from '@/assets';

const $q = useQuasar(),
  router = useRouter(),
  sessionStore = useSessionStore(),
  {t} = useI18n();

onMounted(() => {
  document.querySelectorAll('html')[0].scrollTop = 0;

  sessionStore.setIsHeaderVisible(true);
})

const onOkayClicked = async () => {
  
  // Mark the "About Your Data" interrupt as completed.
  await handleApiRequest(() => setProcedureConsent(), null, $q);
  
  await router.push({ name: 'Interrupts', params: { reload: 'false' } });
}

</script>

<template>
  <q-page class="text-center" padding>
    <zbm-box :box-bkgd-color="$zb.enums.BoxBackgroundColorEnum.linearGradient"
             :box-padding="$zb.enums.BoxPaddingEnum.p303040">

      <!-- Heading -->
      <h2 class="text-weight-regular mb-32">{{ t('gen_privacy') }}</h2>

      <!-- Shield Heart Icon -->
      <div class="shield-heart-icon">
        <div class="shield-heart-circle">
          <Svg :view-box="shieldHeart.viewBox"
               :vector-paths="shieldHeart.vectorPaths" />
        </div>
      </div>

      <!-- Content -->
      <h3>{{ t('about_your_data_header') }}</h3>
      <p>{{ t('about_your_data_body_upper') }}</p>
      <p class="last">{{ t('about_your_data_body_lower') }}</p>

      <!-- Okay Button -->
      <zbm-btn @click="onOkayClicked"
               class="glow--white"
               :color="$zb.enums.ButtonStdColorEnum.darkTeal"
               data-testid="okayButton"
               :height="$zb.enums.ButtonHeightEnum.lg"
               :label="t('gen_okay')"
               :width="$zb.enums.ButtonWidthEnum.wFull" />
    </zbm-box>
  </q-page>
</template>

<style lang="scss" scoped>
@use 'sass:map';

.box {
  width: 100%;
  max-width: 375px;
  margin-inline: auto;
  
  h2,
  h3,
  p {
    color: map.get($co-brand-clrs, content-grd-bg-content);
  }
  
  h3 {
    margin-block-end: 19px;
  }
  
  p {
    font-size: 18px;
    
    &.last {
      margin-block-end: 190px;
    }
  }

  // Shield Heart Icon
  .shield-heart-icon,
  .shield-heart-circle {
    background-color: rgba($white, 0.2);
    border-radius: 50%;
  }

  .shield-heart-icon {
    display: inline-block;
    border: 22px solid transparent;
    margin-bottom: 36px;

    .shield-heart-circle {
      $dimension: 160px;

      width: $dimension;
      height: $dimension;
      line-height: 240px;
      color: map.get($co-brand-clrs, content-grd-bg-content);
      text-align: center;

      svg {
        width: 80px;
        height: auto;
      }
    }
  }
}
</style>